import type { CategoryBaseSchema } from '~/types/product.model'
import type { UseStateType } from '~/types/utils/use-state-type'

// This is used to extract the right types from Nuxt useState
type Types = UseStateType<CategoryBaseSchema[] | null>

/**
 * A type-safe wrapper around `useState`
 */
export const useCategoriesState = (init: Types['firstParam'] = undefined): Types['return'] =>
  useState<Types['state']>('categories', init)
